import { Injectable } from '@angular/core';

import { UserMedcardGrpcContractService } from '@lyra/app/core/api/grpc/services/user-medcard.service';
import { ErrorService } from '@lyra/app/core/services/error.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, filter, map, switchMap, tap, withLatestFrom } from 'rxjs';

import * as actions from '../actions/medical-questions.actions';
import { CHANGE_ROUTE } from '../actions/questionnaire.actions';
import { GET_QUESTIONS } from '../actions/questions.actions';
import { MedicalQuestionsSelectService } from '../selectors/medical-questions.selector';
import { QuestionnaireSelectService } from '../selectors/questionnaire.selector';
import { QuestionsSelectService } from '../selectors/questions.selector';
import { SurveySelectService } from '../selectors/survey.selector';
import { IQuestionnaireState } from '../states/questionnaire.state';

@Injectable()
export class MedicalQuestionsEffects {
  setAnswer$ = createEffect(() =>
    this._actions$.pipe(
      ofType(actions.ANSWER_QUESTION_COMMAND),
      withLatestFrom(this._medicalQuestionsSelect.isLastQuestion()),
      map(([{ questionId, answer }, isLastQuestion]) =>
        actions.ANSWER_QUESTION_SUCCESS({ questionId, answer, isLastQuestion }),
      ),
    ),
  );

  answeredAllQuestions$ = createEffect(() =>
    this._actions$.pipe(
      ofType(actions.ANSWER_QUESTION_SUCCESS),
      filter((x) => !!x.isLastQuestion),
      map(() => actions.SEND_ANSWERED_QUESTIONS_COMMAND()),
    ),
  );

  sendAnsweredQuestions$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType(actions.SEND_ANSWERED_QUESTIONS_COMMAND),
        withLatestFrom(this._medicalQuestionsSelect.getMedicalData(), this._questionsSelect.hasQuestions()),
        tap(() => {
          this._store$.dispatch(CHANGE_ROUTE({ route: 'questions' }));
        }),
        map(([, MedicalData, hasQuestions]) => {
          return {
            MedicalData,
            hasQuestions,
          };
        }),
        switchMap(({ MedicalData, hasQuestions }) =>
          this._userMedcardGrpcContractService.update(MedicalData).pipe(
            tap(() => {
              this._store$.dispatch(actions.SEND_ANSWERED_QUESTIONS_SUCCESS());
              if (!hasQuestions) {
                this._store$.dispatch(GET_QUESTIONS());
              }
            }),
            catchError((response) =>
              this._errorService.handleApiError(response, 'UserMedcardGrpcContractClient.Update'),
            ),
          ),
        ),
      ),
    { dispatch: false },
  );

  constructor(
    private _store$: Store<IQuestionnaireState>,
    private _actions$: Actions,
    private _medicalQuestionsSelect: MedicalQuestionsSelectService,
    private _questionnaireSelect: QuestionnaireSelectService,
    private _userMedcardGrpcContractService: UserMedcardGrpcContractService,
    private _questionsSelect: QuestionsSelectService,
    private _surveySelect: SurveySelectService,
    private _errorService: ErrorService,
  ) {}
}
